import type { TableColumns } from '@ohpen/enso-ui';
import { FirmGetAllResponse, FieldType, FirmDraftDataRow, type FirmsSqeFilterNode } from '@pmp/api';
import type { SqeFields, SqeSort } from '@pmp/utils';

export const columns: TableColumns<FirmGetAllResponse> = [
  {
    title: 'firms.labels.ohpenId',
    dataIndex: 'ohpenId',
    key: 'id',
    width: 300,
    fixed: 'left',
    options: {
      filter: 'search',
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'firms.labels.name',
    dataIndex: 'name',
    key: 'name',
    width: 300,
    fixed: 'left',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'firms.labels.isAuthorised',
    dataIndex: 'isAuthorised',
    key: 'isAuthorised',
    width: 140,
    options: {
      format: {
        type: 'boolean',
      },
      filter: 'select',
      listName: FieldType.YES_NO,
      hide: true,
    },
  },
  {
    title: 'firms.labels.reference',
    dataIndex: 'reference',
    key: 'reference',
    width: 120,
    options: {
      filter: 'search',
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'firms.labels.type',
    dataIndex: 'type',
    key: 'type',
    width: 180,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.FIRM_TYPE,
      sorter: true,
    },
  },
  {
    title: 'firms.labels.frn',
    dataIndex: 'frn',
    key: 'frn',
    width: 120,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'firms.labels.nacfbNumber',
    dataIndex: 'nacfbNumber',
    key: 'nacfbNumber',
    width: 120,
    options: {
      filter: 'search',
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'firms.labels.fcaStatus',
    dataIndex: 'fcaStatus',
    key: 'fcaStatus',
    width: 240,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'firms.labels.principalFirm',
    dataIndex: 'principalFirm',
    key: 'principalFirm',
    width: 200,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.PRINCIPALS,
      hide: true,
    },
  },
  {
    title: 'firms.labels.operations',
    dataIndex: 'operationsWhitelist',
    key: 'operationsWhitelist',
    width: 120,
    options: {
      format: {
        type: 'multiValueList',
      },
      filter: 'select',
      listName: FieldType.OPERATION_TYPE,
    },
  },
  {
    title: 'firms.labels.btl',
    dataIndex: 'btl',
    key: 'btl',
    width: 190,
    options: {
      format: { type: 'valueList' },
      filter: 'select',
      listName: FieldType.CASE_PERMISSION_TYPE,
    },
  },
  {
    title: 'firms.labels.rbtl',
    dataIndex: 'rbtl',
    key: 'rbtl',
    width: 180,
    options: {
      format: { type: 'valueList' },
      filter: 'select',
      listName: FieldType.CASE_PERMISSION_TYPE,
    },
  },
  {
    title: 'firms.labels.rmc',
    dataIndex: 'rmc',
    key: 'rmc',
    width: 160,
    options: {
      format: { type: 'valueList' },
      filter: 'select',
      listName: FieldType.CASE_PERMISSION_TYPE,
    },
  },
  {
    title: 'firms.labels.firmCompliance',
    dataIndex: 'firmCompliance',
    key: 'complianceStatus',
    width: 150,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.COMPLIANCE_STATUS,
    },
  },
  {
    title: 'firms.labels.isActive',
    dataIndex: 'isActive',
    key: 'isActive',
    width: 120,
    options: {
      format: {
        type: 'boolean',
      },
      filter: 'select',
      listName: FieldType.YES_NO,
    },
  },
  {
    title: 'firms.labels.defaultPaymentRoute',
    dataIndex: 'defaultPaymentRouteFirm',
    key: 'defaultPaymentRouteFirm',
    width: 180,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.FIRMS,
      sorter: true,
    },
  },
  {
    title: 'firms.labels.activationDate',
    dataIndex: 'activationDate',
    key: 'activationDate',
    width: 120,
    options: {
      format: {
        type: 'date',
      },
      filter: 'date',
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'firms.labels.deactivationDate',
    dataIndex: 'deactivationDate',
    key: 'deactivationDate',
    width: 120,
    options: {
      format: {
        type: 'date',
      },
      filter: 'date',
      sorter: true,
      hide: true,
    },
  },
  { title: 'enso.labels.actions', dataIndex: '', key: 'actions', width: 100, fixed: 'right' },
];

export const firmCRColumns: TableColumns<FirmDraftDataRow> = [
  {
    title: 'firms.labels.name',
    dataIndex: 'name',
    key: 'name',
    width: 200,
    options: {
      sorter: true,
    },
  },
  {
    title: 'firms.labels.type',
    dataIndex: 'type',
    key: 'type',
    width: 120,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.FIRM_TYPE,
      sorter: true,
    },
  },
  {
    title: 'firms.labels.isActive',
    dataIndex: 'isActive',
    key: 'isActive',
    width: 120,
    options: {
      format: {
        type: 'boolean',
      },
      filter: 'select',
      listName: FieldType.YES_NO,
    },
  },
  {
    title: 'firms.labels.reference',
    dataIndex: 'reference',
    key: 'reference',
    width: 120,
    options: {
      sorter: true,
    },
  },
  {
    title: 'firms.labels.frn',
    dataIndex: 'frn',
    key: 'frn',
    width: 120,
    options: {
      sorter: true,
    },
  },
];

// Mirrors FirmImportSchemaFields so an export can be fed back into the firm import. Each key reads
// the column of the same name from the rows the list exports (exportRows.ts), which already hold
// the values the import parses.
export const firmExportColumns: TableColumns<FirmGetAllResponse> = [
  {
    title: 'firms.labels.ohpenId',
    dataIndex: 'ohpenId',
    key: 'ohpenId',
  },
  {
    title: 'firms.labels.name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'firms.labels.type',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: 'firms.labels.frn',
    dataIndex: 'frn',
    key: 'frn',
  },
  {
    title: 'firms.labels.isActive',
    dataIndex: 'isActive',
    key: 'isActive',
  },
  {
    title: 'firms.labels.nacfbNumber',
    dataIndex: 'nacfbNumber',
    key: 'nacfbNumber',
  },
  {
    title: 'firms.labels.reference',
    dataIndex: 'reference',
    key: 'reference',
  },
  {
    title: 'firms.labels.qualifiedDomains',
    dataIndex: 'qualifiedDomains',
    key: 'qualifiedDomains',
  },
  {
    title: 'firms.labels.btl',
    dataIndex: 'btl',
    key: 'btl',
  },
  {
    title: 'firms.labels.rbtl',
    dataIndex: 'rbtl',
    key: 'rbtl',
  },
  {
    title: 'firms.labels.rmc',
    dataIndex: 'rmc',
    key: 'rmc',
  },
  {
    title: 'firms.labels.operations',
    dataIndex: 'operations',
    key: 'operations',
  },
  {
    title: 'firms.labels.adviceBankAccountName',
    dataIndex: 'adviceBankAccountName',
    key: 'adviceBankAccountName',
  },
  {
    title: 'firms.labels.adviceBankAccountSortCode',
    dataIndex: 'adviceBankAccountSortCode',
    key: 'adviceBankAccountSortCode',
  },
  {
    title: 'firms.labels.adviceBankAccountAccountNumber',
    dataIndex: 'adviceBankAccountAccountNumber',
    key: 'adviceBankAccountAccountNumber',
  },
  {
    title: 'firms.labels.adviceBankAccountBankName',
    dataIndex: 'adviceBankAccountBankName',
    key: 'adviceBankAccountBankName',
  },
  {
    title: 'firms.labels.packageBankAccountName',
    dataIndex: 'packageBankAccountName',
    key: 'packageBankAccountName',
  },
  {
    title: 'firms.labels.packageBankAccountSortCode',
    dataIndex: 'packageBankAccountSortCode',
    key: 'packageBankAccountSortCode',
  },
  {
    title: 'firms.labels.packageBankAccountAccountNumber',
    dataIndex: 'packageBankAccountAccountNumber',
    key: 'packageBankAccountAccountNumber',
  },
  {
    title: 'firms.labels.packageBankAccountBankName',
    dataIndex: 'packageBankAccountBankName',
    key: 'packageBankAccountBankName',
  },
  {
    title: 'firms.labels.networkBankAccountName',
    dataIndex: 'networkBankAccountName',
    key: 'networkBankAccountName',
  },
  {
    title: 'firms.labels.networkBankAccountSortCode',
    dataIndex: 'networkBankAccountSortCode',
    key: 'networkBankAccountSortCode',
  },
  {
    title: 'firms.labels.networkBankAccountAccountNumber',
    dataIndex: 'networkBankAccountAccountNumber',
    key: 'networkBankAccountAccountNumber',
  },
  {
    title: 'firms.labels.networkBankAccountBankName',
    dataIndex: 'networkBankAccountBankName',
    key: 'networkBankAccountBankName',
  },
  {
    title: 'firms.labels.mortgageClubBankAccountName',
    dataIndex: 'mortgageClubBankAccountName',
    key: 'mortgageClubBankAccountName',
  },
  {
    title: 'firms.labels.mortgageClubBankAccountSortCode',
    dataIndex: 'mortgageClubBankAccountSortCode',
    key: 'mortgageClubBankAccountSortCode',
  },
  {
    title: 'firms.labels.mortgageClubBankAccountAccountNumber',
    dataIndex: 'mortgageClubBankAccountAccountNumber',
    key: 'mortgageClubBankAccountAccountNumber',
  },
  {
    title: 'firms.labels.mortgageClubBankAccountBankName',
    dataIndex: 'mortgageClubBankAccountBankName',
    key: 'mortgageClubBankAccountBankName',
  },
  {
    title: 'firms.labels.principalFirm',
    dataIndex: 'principal',
    key: 'principal',
  },
  {
    title: 'firms.labels.packagers',
    dataIndex: 'packagers',
    key: 'packagers',
  },
  {
    title: 'firms.labels.paymentRoutes',
    dataIndex: 'paymentRoutes',
    key: 'paymentRoutes',
  },
  {
    title: 'firms.labels.defaultPaymentRoute',
    dataIndex: 'defaultPaymentRoute',
    key: 'defaultPaymentRoute',
  },
  {
    title: 'firms.labels.contactEmail',
    dataIndex: 'contactEmail',
    key: 'contactEmail',
  },
  {
    title: 'firms.labels.contactMobilePhone',
    dataIndex: 'contactMobilePhone',
    key: 'contactMobilePhone',
  },
  {
    title: 'firms.labels.contactTelephone',
    dataIndex: 'contactTelephone',
    key: 'contactTelephone',
  },
  {
    title: 'firms.labels.contactWebsite',
    dataIndex: 'contactWebsite',
    key: 'contactWebsite',
  },
  {
    title: 'firms.labels.contactComplaintsWebsite',
    dataIndex: 'contactComplaintsWebsite',
    key: 'contactComplaintsWebsite',
  },
  {
    title: 'firms.labels.addressPostCode',
    dataIndex: 'addressPostCode',
    key: 'addressPostCode',
  },
  {
    title: 'firms.labels.addressTown',
    dataIndex: 'addressTown',
    key: 'addressTown',
  },
  {
    title: 'firms.labels.addressCounty',
    dataIndex: 'addressCounty',
    key: 'addressCounty',
  },
  {
    title: 'firms.labels.addressCountry',
    dataIndex: 'addressCountry',
    key: 'addressCountry',
  },
  {
    title: 'firms.labels.addressLineOne',
    dataIndex: 'addressLineOne',
    key: 'addressLineOne',
  },
  {
    title: 'firms.labels.addressLineTwo',
    dataIndex: 'addressLineTwo',
    key: 'addressLineTwo',
  },
  {
    title: 'firms.labels.addressLineThree',
    dataIndex: 'addressLineThree',
    key: 'addressLineThree',
  },
  {
    title: 'firms.labels.addressLineFour',
    dataIndex: 'addressLineFour',
    key: 'addressLineFour',
  },
  {
    title: 'firms.labels.tradingAddressId',
    dataIndex: 'tradingAddressId',
    key: 'tradingAddressId',
  },
  {
    title: 'firms.labels.tradingAddressName',
    dataIndex: 'tradingAddressName',
    key: 'tradingAddressName',
  },
  {
    title: 'firms.labels.tradingAddressPostCode',
    dataIndex: 'tradingAddressPostCode',
    key: 'tradingAddressPostCode',
  },
  {
    title: 'firms.labels.tradingAddressTown',
    dataIndex: 'tradingAddressTown',
    key: 'tradingAddressTown',
  },
  {
    title: 'firms.labels.tradingAddressCounty',
    dataIndex: 'tradingAddressCounty',
    key: 'tradingAddressCounty',
  },
  {
    title: 'firms.labels.tradingAddressCountry',
    dataIndex: 'tradingAddressCountry',
    key: 'tradingAddressCountry',
  },
  {
    title: 'firms.labels.tradingAddressLineOne',
    dataIndex: 'tradingAddressLineOne',
    key: 'tradingAddressLineOne',
  },
  {
    title: 'firms.labels.tradingAddressLineTwo',
    dataIndex: 'tradingAddressLineTwo',
    key: 'tradingAddressLineTwo',
  },
  {
    title: 'firms.labels.tradingAddressLineThree',
    dataIndex: 'tradingAddressLineThree',
    key: 'tradingAddressLineThree',
  },
  {
    title: 'firms.labels.tradingAddressLineFour',
    dataIndex: 'tradingAddressLineFour',
    key: 'tradingAddressLineFour',
  },
  {
    title: 'firms.labels.tradingAddressRegion',
    dataIndex: 'tradingAddressRegion',
    key: 'tradingAddressRegion',
  },
  {
    title: 'firms.labels.tradingAddressBdm',
    dataIndex: 'tradingAddressBdm',
    key: 'tradingAddressBdm',
  },
];

export const firmSqeFields: SqeFields<FirmsSqeFilterNode> = {
  ohpenId: { kind: 'text' },
  name: { kind: 'text' },
  isAuthorised: { kind: 'boolean' },
  reference: { kind: 'text', nullable: true },
  type: { kind: 'enum' },
  frn: { kind: 'identifier', nullable: true },
  nacfbNumber: { kind: 'text', nullable: true },
  fcaStatus: { kind: 'text', nullable: true },
  principalFirm: { kind: 'reference', nullable: true },
  operationsWhitelist: { kind: 'collection', key: 'key' },
  btl: { kind: 'enum' },
  rbtl: { kind: 'enum' },
  rmc: { kind: 'enum' },
  firmCompliance: { kind: 'enum' },
  isActive: { kind: 'boolean' },
  defaultPaymentRouteFirm: { kind: 'reference', nullable: true },
  activationDate: { kind: 'date', nullable: true },
  deactivationDate: { kind: 'date', nullable: true },
};

export const firmSqeDefaultSort: SqeSort = [{ field: 'name', dir: 'asc' }];
